import {ReactNode} from 'react';
import {Provider} from 'react-redux';
import {DeepPartial} from '@reduxjs/toolkit';
import {RootState, setupStore} from "../store";
import {PersistGate} from "redux-persist/integration/react";
import {persistStore} from "redux-persist";

interface StoreProviderProps {
    children?: ReactNode;
    initialState?: DeepPartial<RootState>;
}

export const StoreProvider = (props: StoreProviderProps) => {
    const {
        children,
        initialState,
    } = props;

    const store = setupStore(
        initialState
    )

    const persistor = persistStore(store);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};
